import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import EarnestMoneyListPage from '../components/EarnestMoneyListPage'
import {
  actionCreators,
  IEarnestMoneyListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectTotalItems,
} from '../modules/earnestMoneyList'

export default connect(
  createStructuredSelector<ApplicationState, IEarnestMoneyListState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(EarnestMoneyListPage)
